import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBillingTimer } from "../../hooks/useBillingTimer";
import { useAppSelector } from "../../Redux/hooks";

const BillingManager = () => {
  const { participantId } = useParams<{ participantId: string }>();
  const { handleStart, handleStop } = useBillingTimer();
  const isActive = useAppSelector((state) => state.billingTimer.isActive);

  useEffect(() => {
    // Check if participantId exists
    if (!participantId) {
      return;
    }

    if (!isActive) {
      handleStart();
    }
  }, [participantId, isActive, handleStart, handleStop]);

  // Cleanup: stop timer when component unmounts (leaving participant routes)
  useEffect(() => {
    return () => {
      console.log("unmounting participant details wrapper");
      // Always call handleStop on unmount - it checks isActive internally
      // This ensures timer is stopped when leaving participant routes
      handleStop();
    };
  }, [handleStop]);

  return null;
};

export default BillingManager;
